/* Modal Directional Slide Effect  */
/********************************************************/
var modal, direction;

$("[data-toggle=modal]").click(function () {
    direction = $(this).data("direction");
    modal = $(this).data("target");

    $(modal).on("show.bs.modal", function (e) {
        $(modal).addClass(direction);
    });

    $(modal).on("hide.bs.modal", function (e) {
        $(modal).removeClass(direction);
    });
});